export default __webpack_public_path__ + "static/media/ANIMATOR_JEST.4abc6010.png";